import React, { useCallback, useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import reactLogger from 'utils/logger';
import {
  Box,
  Avatar,
  Typography,
  CircularProgress,
  Fade,
  useTheme,
  Collapse,
  Button,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useProductChatgroup } from 'scenes/ProductDetails_page/store/selectors';
import { ReducerKeys } from 'redux/config';
import { useHistory, withRouter } from 'react-router';
import withReducer from 'redux/withReducer';
import ChatBox, {
  CollapsingChatBox,
} from 'components/compounds/Chat/components/ChatBox';
import socket from 'providers/SocketioProvider/chat';

import * as faceapi from 'face-api.js';
import request from 'utils/request';
import { Environment } from 'config';
import { useSelectUserData } from 'redux/reducers/gl_auth_reducer/selectors';
import { Unity, useUnityContext } from 'react-unity-webgl';

import happy from 'assets/images/faces/happy.png';
import neutral from 'assets/images/faces/neutral.png';
import sad from 'assets/images/faces/sad.png';
import angry from 'assets/images/faces/angry.png';
import useMobile from 'hooks/useMobile';

interface IExpression {
  angry: number;
  disgusted: number;
  fearful: number;
  happy: number;
  neutral: number;
  sad: number;
  surprised: number;
}

var unityInstance: any = null;
const path = '_game/Build/Web';
const streamingAssetsPath = '_game/StreamingAssets';

const event = 'conversation.start';

function emotionToImg(emotion: string | null) {
  if (!emotion) return null;

  switch (emotion) {
    case 'happy':
      return happy;
    case 'angry':
      return angry;
    case 'sad':
      return sad;
    case 'neutral':
      return neutral;
    default:
      return null;
  }
}

/*
 * For this component to work, a unity WebGL export must be placed inside the public directory under ${path}
 */
function GameScene() {
  // reactLogger.log('GameScene');
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelectUserData();
  const isMobile = useMobile();

  const [emotionStr, setEmotionStr] = useState<string | null>(null);
  const emotionImg = emotionToImg(emotionStr);
  const [videoToggle, setVideoToggle] = useState(false);
  const video = document.getElementById('video') as HTMLVideoElement;
  const interval = useRef<any>(null);

  async function startVideo() {
    if (!video) return;

    console.log('starting streaming');
    navigator.mediaDevices
      .getUserMedia({ video: {} })
      .then((stream) => {
        if (video) {
          video.srcObject = stream;
          console.log('video src set');
          video.play();
        }
      })
      .catch((err) => console.error(err));
  }

  async function stopVideo() {
    if (interval.current != null) clearInterval(interval.current);

    if (!video) return;
    console.log('stopping streaming');
    video.pause();
  }

  const videoCallback = useCallback(async () => {
    if (!videoToggle) return;

    const detection: any = await faceapi
      .detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks()
      .withFaceExpressions();
    // console.log(detection);

    const expressions: IExpression = _.get(detection, 'expressions', null);
    if (expressions && Object.keys(expressions).length > 0) {
      const emotion: string = Object.keys(expressions).reduce((a, b) =>
        _.get(expressions, a) > _.get(expressions, b) ? a : b
      );
      console.log(emotion, _.get(expressions, emotion));
      setEmotionStr(emotion);

      request(
        'post',
        `${Environment.API_BASE_URL}/api/game/log/emotion/insert`,
        {
          body: {
            emotion: emotion,
            user_id: user.id,
          },
        }
      );
    }

    // const detections = await faceapi
    //   .detectAllFaces(video, new faceapi.TinyFaceDetectorOptions())
    //   .withFaceLandmarks()
    //   .withFaceExpressions();
    // console.log(detections);

    // const resizedDetections = faceapi.resizeResults(
    //   detections,
    //   displaySize
    // );
    // canvas.getContext('2d')?.clearRect(0, 0, canvas.width, canvas.height);
    // faceapi.draw.drawDetections(canvas, resizedDetections);
    // faceapi.draw.drawFaceLandmarks(canvas, resizedDetections);
    // faceapi.draw.drawFaceExpressions(canvas, resizedDetections);
  }, [videoToggle]);

  const { unityProvider, isLoaded, loadingProgression, unload } =
    useUnityContext({
      loaderUrl: `${path}.loader.js`,
      dataUrl: `${path}.data`,
      frameworkUrl: `${path}.framework.js`,
      codeUrl: `${path}.wasm`,
      streamingAssetsUrl: streamingAssetsPath,
    });

  const [chatgroupIds, setChatgroupIds] = useState<string[]>([]);

  const action = (data: any) => {
    console.log('conversation.start', chatgroupIds, data);
    if (!chatgroupIds.find((el) => el == data)) {
      setChatgroupIds([data, ...chatgroupIds]);
      console.log(chatgroupIds);
      // console.log(chatgroupIds);
    } else {
      // console.log('chat already open');
    }
  };

  useEffect(() => {
    socket.on(event, action);
    return () => {
      socket.removeListener(event, action);
    };
  }, [socket.connected, action]);

  useEffect(() => {
    if (!video) return;

    if (videoToggle) {
      // const canvas = faceapi.createCanvasFromMedia(video);
      const canvas = faceapi.createCanvas(video);
      document.body.append(canvas);

      const displaySize = { width: video.width, height: video.height };
      faceapi.matchDimensions(canvas, displaySize);

      interval.current = setInterval(videoCallback, 5000);

      Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
        faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
        faceapi.nets.faceRecognitionNet.loadFromUri('/models'),
        faceapi.nets.faceExpressionNet.loadFromUri('/models'),
      ]).then(startVideo);
    } else {
      stopVideo();
    }

    return () => {
      stopVideo();
    };
  }, [videoToggle]);

  const quitAction = () => {
    unload().then(() => {
      history.push('/home');
    });
  };

  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: 'white',
        zIndex: 2000,
        // height: `calc(100vh - ${theme.spacing(8)}px`,
        // position: 'relative',
        // display: 'flex',
        // flex: 1,
      }}
    >
      {isMobile ? (
        <>
          <Box
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <Box
              style={{
                position: 'absolute',
                left: '50%',
                right: '50%',
                top: '50%',
                bottom: '50%',
                // transform: 'translate(-50%, -50%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography style={{ display: 'inline-block' }}>
                {`Please use a Computer to access the 3D Mall`}
              </Typography>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Box
            style={{
              position: 'absolute',
              zIndex: 2000,
              padding: '0.2em',
            }}
          >
            <Collapse in={videoToggle}>
              <video
                id="video"
                width={200}
                style={{
                  backgroundColor: '#5b5e5c',
                  borderRadius: 10,
                  boxShadow: '0 0 10px rgb(0, 0, 0, 0.5)',
                }}
              />
            </Collapse>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2em',
              }}
            >
              <Typography>Emotion Capture</Typography>
              <label className="switch">
                <input
                  checked={videoToggle}
                  onChange={(e) => {
                    setVideoToggle(e.currentTarget.checked);
                  }}
                  type="checkbox"
                />
                <span className="slider round"></span>
              </label>
            </Box>
            {videoToggle && emotionStr && (
              <Box
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                }}
              >
                <Typography component={'span'}>{emotionStr}</Typography>
                {emotionImg && <img src={emotionImg} width={50} height={50} />}
              </Box>
            )}
          </Box>

          <Box
            style={{
              position: 'absolute',
              top: '1em',
              right: '2em',
              zIndex: 2000,
            }}
          >
            <Button variant={'contained'} onClick={() => quitAction()}>
              Quit
            </Button>
          </Box>

          <Fade in={isLoaded} timeout={2000}>
            <Unity
              unityProvider={unityProvider}
              tabIndex={1}
              style={{
                position: 'absolute',
                height: '100%',
                width: '100%',
                backgroundColor: '#5b5e5c',
              }}
            />
          </Fade>

          <Fade in={!isLoaded} timeout={2000}>
            <Box
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
              }}
            >
              <CircularProgress
                variant={'determinate'}
                value={loadingProgression * 100}
                size={150}
                style={{
                  position: 'absolute',
                  left: '50%',
                  right: '50%',
                  top: '50%',
                  bottom: '50%',
                  zIndex: 2000,
                  transform: 'translate(-50%, -50%)',
                }}
              />
              <Box
                style={{
                  position: 'absolute',
                  left: '50%',
                  right: '50%',
                  top: '50%',
                  bottom: '50%',
                  // transform: 'translate(-50%, -50%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography style={{ display: 'inline-block' }}>
                  {`${isLoaded ? 'Loading' : 'initialising'}`}
                </Typography>
              </Box>
            </Box>
          </Fade>

          <Box
            style={{
              display: 'flex',
              flexDirection: 'row-reverse',
              position: 'fixed',
              bottom: 0,
              right: '1em',
              gap: '1em',
              alignItems: 'flex-end',
            }}
          >
            {chatgroupIds.map((chatId, index) => (
              <CollapsingChatBox
                key={index}
                chatgroupId={chatId}
                right={`${20 + index * 420}px`}
              />
            ))}
          </Box>
        </>
      )}
    </div>
  );
}

const Page = withRouter(GameScene);
export default withReducer(ReducerKeys.PRODUCT_DETAILS_REDUCER)(Page);
